// Modules
import { CommonModule } from '@angular/common';
import { DisabledModule } from 'NewAngular/features/directives/disabled/disabled.module';
import { IconModule } from 'NewAngular/features/directives/icon/icon.module';
import * as i0 from "@angular/core";
export class SimplePaginationControlsModule {
}
SimplePaginationControlsModule.ɵfac = function SimplePaginationControlsModule_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || SimplePaginationControlsModule)(); };
SimplePaginationControlsModule.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: SimplePaginationControlsModule });
SimplePaginationControlsModule.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ imports: [CommonModule, DisabledModule, IconModule] });
